import AppLogo from './PROJkt.svg';
import AppLogoWhite from './PROJktWhite.svg';
import TileEmptyImage from './TileEmptyImage.svg';
import Card from './Card.svg';

export const Images = {
    AppLogo,
    AppLogoWhite,
    TileEmptyImage,
    Card
}